'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.get = get;
exports.set = set;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var supportedCached = null;

function get(name) {
    if (!isSupported()) {
        return _promise2.default.resolve();
    }
    return new _promise2.default(function (resolve) {
        resolve(window.localStorage.getItem(name));
    });
}

function set(name, val) {
    if (!isSupported()) {
        return _promise2.default.resolve();
    }
    return new _promise2.default(function (resolve) {
        resolve(window.localStorage.setItem(name, val));
    });
}

function isSupported() {
    if (supportedCached === null) {
        supportedCached = storageAvailable('localStorage');
    }
    return supportedCached;
}

function storageAvailable(type) {
    var storage = void 0;
    try {
        var x = '__storage_test__';
        storage = window[type];
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && storage.length !== 0;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/libs/storage/Local.js
// module id = 3GM/
// module chunks = 1